export const channels = [
  {
    id: "airbnb", label: "airbnb", cls: "m-airbnb", color: "#FF385C", file: "/logos/airbnb.svg", h: 30,
    desc: {
      en: "Our largest audience of leisure travellers and longer stays.",
      id: "Audiens terbesar kami untuk wisatawan leisure dan masa inap panjang.",
    },
  },
  {
    id: "booking", label: "Booking.com", cls: "m-booking", color: "#0071C2", file: "/logos/booking.svg", h: 26,
    desc: {
      en: "Strong reach across Europe and international travellers.",
      id: "Jangkauan kuat di Eropa dan wisatawan internasional.",
    },
  },
  {
    id: "agoda", label: "agoda", cls: "m-agoda", color: "#00A9DC", file: "/logos/agoda.svg", h: 44,
    desc: {
      en: "A leading platform for travellers from across Asia.",
      id: "Platform terkemuka untuk wisatawan dari seluruh Asia.",
    },
  },
  {
    id: "expedia", label: "Expedia", cls: "m-expedia", color: "#3662D8", file: "/logos/expedia.svg", h: 26,
    desc: {
      en: "Global reach, including North American guests.",
      id: "Jangkauan global, termasuk tamu dari Amerika Utara.",
    },
  },
  {
    id: "vrbo", label: "Vrbo", cls: "m-vrbo", color: "#0F51EC", file: "/logos/vrbo.svg", h: 36,
    desc: {
      en: "Built for families and groups booking whole homes.",
      id: "Dibangun untuk keluarga dan grup yang memesan seluruh rumah.",
    },
  },
  {
    id: "eden", eden: true,
    desc: {
      en: "Book direct on edenhospitalitybali.com: our best rate, no platform fees.",
      id: "Pesan langsung di edenhospitalitybali.com: tarif terbaik kami, tanpa biaya platform.",
    },
  },
];
